module.exports = __webpack_public_path__ + "img/cavalier-challenge-1-mobile_bb957406368101f34ad94d9ed6c2cf41.jpg";


//////////////////
// WEBPACK FOOTER
// ./client/img/cavalier-challenge-1-mobile.jpg
// module id = 262
// module chunks = 0